import { externalPlugin } from './infrastructure/plugins/external';
import { communication } from './infrastructure/plugins/communication';
import './assets/styles/tailwind.css';
import { CopilotButton, CopilotChat, Copilot } from './ui/Copilot';

// Função de instalação para o projeto principal
const install = (app: any, options: { axios?: any; store?: any; apiUrl?: string } = {}) => {
  if (!app || !app.config) {
    throw new Error('Invalid Vue app instance provided');
  }

  const axiosInstance = options.axios || {
    get: async () => ({ data: { name: 'Usuário Teste', email: 'teste@exemplo.com' } }),
    post: async () => ({ data: { success: true } }),
  };

  // Instala o plugin externo
  app.use(externalPlugin, {
    axios: axiosInstance,
    store: options.store || {
      state: { theme: 'light' },
      dispatch: () => {},
    },
  });
  // Adiciona o eventBus
  app.prototype.$eventBus = communication;
};

export { communication, CopilotChat, CopilotButton, Copilot };

export default {
  install,
};
